import { batch } from 'react-redux';
import { normalize } from 'normalizr';

import { SITE_FOOTER_LINKS_SCHEMA, CATEGORIES_SCHEMA } from '../schemas';

import {
  ACTION_ADD_CATEGORIES,
  ACTION_ADD_LINKS,
  ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP,
  ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED,
  ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED,
  ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS,
} from '../actionTypes';


const actionAddCategories = categories => ({
  type: ACTION_ADD_CATEGORIES,
  payload: { categories: normalize(categories, CATEGORIES_SCHEMA).entities.categories || {} },
});

const actionSetIsSiteLinkCategoriesMaxNumberReached = (
  siteLinkCategoriesMaxNumberReached => ({
    type: ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED,
    payload: { siteLinkCategoriesMaxNumberReached },
  })
);

export const actionAddCategoriesData = (
  dispatch, categories, siteLinkCategoriesMaxNumberReached
) => batch(() => {
  dispatch(actionAddCategories(categories));
  dispatch(actionSetIsSiteLinkCategoriesMaxNumberReached(siteLinkCategoriesMaxNumberReached));
});

export const actionAddLinks = links => {
  const { entities } = normalize(links, SITE_FOOTER_LINKS_SCHEMA);

  return {
    type: ACTION_ADD_LINKS,
    payload: {
      siteFooterLinkTranslations: entities.siteFooterLinkTranslations || {},
      siteFooterLinks: entities.siteFooterLinks || {},
    },
  };
};

const setIsSiteLinkMaxNumberReached = siteLinkMaxNumberReached => ({
  type: ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED,
  payload: { siteLinkMaxNumberReached },
});

export const actionAddLinkData = (
  dispatch, links, siteLinkMaxNumberReached
) => batch(() => {
  dispatch(actionAddLinks(links));
  dispatch(setIsSiteLinkMaxNumberReached(siteLinkMaxNumberReached));
});

export const actionAddTemplateToCategoriesMap = wlTemplateToManifestMap => ({
  type: ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP,
  payload: { wlTemplateToManifestMap },
});

export const actionAddDefaultSiteLinkCategoryTranslations = (
  wlTemplateToPromotedSiteToLangToCategoryToTranslationMap => ({
    type: ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS,
    payload: { wlTemplateToPromotedSiteToLangToCategoryToTranslationMap },
  })
);
